import { render, staticRenderFns } from "./fundusTest.vue?vue&type=template&id=673a5cfa&scoped=true&"
import script from "./fundusTest.vue?vue&type=script&lang=js&"
export * from "./fundusTest.vue?vue&type=script&lang=js&"
import style0 from "./fundusTest.vue?vue&type=style&index=0&id=673a5cfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a5cfa",
  null
  
)

export default component.exports